import { useAuth } from '../../contexts/AuthContext';
import './Avatar.css';

const Avatar = () => {
    const { user } = useAuth();

    return (
        <div id="avatar">
            {user?.avatar && 
                <img className="avatar" src={user.avatar} alt="Avatar" />
            }

            {!user?.avatar && 
                <div className="no-avatar">
                    <span>{user?.firstName?.charAt(0)}</span>
                    <span>{user?.lastName?.charAt(0)}</span>
                </div>
            }
        </div>
    );
}

export default Avatar;